import type { ClientLibrary } from 'types/client-library'

/**
 * Whether the catalog should render with the Artist Profile template.
 */
export const isArtistProfileCatalog = (
  library: Pick<ClientLibrary, 'catalog_type'>,
) => library.catalog_type === 'artist-profile'
